export const selectDishes = (state) => {
  return state.dishes.dishes;
};
